import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { catchError, Observable, of, map as rxMap } from 'rxjs';

import {
  ProposalQuickRaterQuote,
  ProposalQuickRaterQuotePayload,
  ProposalQuickRaterQuoteRaw,
  ProposalQuickRaterQuotes,
} from '@lockton-apps/shared/interfaces';
import { CobMetaService } from '@lockton-apps/shared/util/constants';

import { ProposalLocalStore } from './proposal-local.store';

@Injectable()
export class ProposalLocalFacade {
  quotes$: Observable<ProposalQuickRaterQuotes> = this.localStore.quotes$;
  loadingIds$: Observable<string[]> = this.localStore.loadingIds$;

  readonly additionalProductsIds$ = this.localStore.additionalProductsIds$;

  get quotes(): ProposalQuickRaterQuotes {
    return this.localStore.quotes;
  }

  constructor(
    private readonly localStore: ProposalLocalStore,
    private readonly http: HttpClient,
    private readonly cobMetaService: CobMetaService,
    @Inject('BASE_API_URL') private readonly baseUrl: string
  ) {}

  setAdditionalProductsIds(productsIds: string[]): void {
    this.localStore.setAdditionalProductsIds(productsIds);
  }

  getQuickRaterQuote(
    payload: ProposalQuickRaterQuotePayload
  ): Observable<ProposalQuickRaterQuote> {
    this.localStore.addLoadingId(
      this.cobMetaService.getClassOfBusinessId(payload.classOfBusinessId)
    );

    const quote$: Observable<ProposalQuickRaterQuote> =
      this.fetchQuickRaterQuote(payload);

    this.localStore.updateQuote(quote$);

    return quote$;
  }

  private fetchQuickRaterQuote(
    payload: ProposalQuickRaterQuotePayload
  ): Observable<ProposalQuickRaterQuote> {
    return this.http
      .put<ProposalQuickRaterQuoteRaw>(
        `${this.baseUrl}/quote/quick-quote`,
        payload
      )
      .pipe(
        rxMap((quote) => ({
          ...quote,
          meta: { payload, valid: true },
        })),
        catchError(() =>
          of({
            clientId: payload.clientId,
            classOfBusinessId: payload.classOfBusinessId,
            premium: 0,
            meta: { payload, valid: false },
          })
        )
      );
  }
}
